import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import axios from "axios";

export default function Navbar() {
  const { user, logout, isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();

  const [sellerName, setSellerName] = useState("");
  const sellerToken = localStorage.getItem("sellerToken");
  const sellerId = localStorage.getItem("sellerId");
  const adminToken = localStorage.getItem("adminToken");

  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (sellerToken && sellerId) {
      axios
        .get(`https://haaterkaj-backend-1.onrender.com/api/seller/profile/${sellerId}`, {
          headers: { Authorization: `Bearer ${sellerToken}` },
        })
        .then((res) => {
          if (res.data.success) {
            setSellerName(res.data.seller.name);
            localStorage.setItem("sellerName", res.data.seller.name);
          }
        })
        .catch((err) => console.error("Error fetching seller info:", err));
    }
  }, [sellerToken, sellerId]);

  const handleSellerLogout = () => {
    localStorage.removeItem("sellerToken");
    localStorage.removeItem("sellerId");
    localStorage.removeItem("sellerName");
    navigate("/seller/login");
  };

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const handleAdminLogout = () => {
    localStorage.removeItem("adminToken");
    navigate("/admin/login");
  };

  return (
    <nav className="bg-amber-100 shadow-md sticky top-0 z-50">
      <div className="container mx-auto flex justify-between items-center py-4 px-6">

        {/* Brand */}
       <Link to="/" className="flex items-center gap-2 font-bold text-amber-800">
  <img 
    src="./images/logo.jpg" 
    alt="HaaterKaj Logo" 
    className="w-10 h-10 object-contain"
  />
</Link>

        {/* Hamburger Icon */}
        <button
          className="lg:hidden block text-3xl text-amber-800"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? "✖" : "☰"}
        </button>

        {/* NAV MENU */}
        <div
          className={`
            flex flex-col lg:flex lg:flex-row lg:items-center lg:justify-end gap-6
            absolute lg:static bg-amber-100 
            w-full px-6 py-6 lg:py-0 
            shadow-lg lg:shadow-none transition-all duration-300
            right-0
            ${menuOpen ? "top-16 opacity-100 visible" : "top-[-500px] opacity-0 invisible lg:visible lg:opacity-100"}
          `}
        >
          <Link onClick={() => setMenuOpen(false)} to="/" className="hover:text-amber-700 font-medium">
            Home
          </Link>

          <Link onClick={() => setMenuOpen(false)} to="/products" className="hover:text-amber-700 font-medium">
            Products
          </Link>

          <Link onClick={() => setMenuOpen(false)} to="/about" className="hover:text-amber-700 font-medium">
            About
          </Link>

          <Link onClick={() => setMenuOpen(false)} to="/contact" className="hover:text-amber-700 font-medium">
            Contact Us
          </Link>

          {/* ADMIN SECTION */}
          {adminToken && (
            <div className="flex flex-col lg:flex-row gap-4">
              <Link
                onClick={() => setMenuOpen(false)}
                to="/admin/dashboard"
                className="bg-amber-700 text-white px-4 py-1 rounded-lg hover:bg-amber-800"
              >
                Admin Dashboard
              </Link>
              <button
                onClick={() => {
                  setMenuOpen(false);
                  handleAdminLogout();
                }}
                className="bg-red-600 text-white px-4 py-1 rounded-lg hover:bg-red-700"
              >
                Logout
              </button>
            </div>
          )}

          {/* USER SECTION */}
          {!adminToken && isAuthenticated && (
            <div className="flex flex-col lg:flex-row gap-4">
              <span className="font-semibold text-amber-800">
                👋 Hi, {user?.name || "User"}
              </span>
              <button
                onClick={() => {
                  setMenuOpen(false);
                  handleLogout();
                }}
                className="bg-red-500 text-white px-4 py-1 rounded-lg hover:bg-red-600"
              >
                Logout
              </button>
            </div>
          )}

          {/* SELLER SECTION */}
          {!adminToken && !isAuthenticated && (
            <>
              {!sellerToken ? (
                <Link
                  onClick={() => setMenuOpen(false)}
                  to="/seller/login"
                  className="bg-orange-600 text-white px-4 py-1 rounded-lg hover:bg-orange-700"
                >
                  Seller Login
                </Link>
              ) : (
                <div className="flex flex-col lg:flex-row gap-4">
                  <span className="font-semibold text-green-800">
                    👋 Hi, {sellerName || "Seller"}
                  </span>

                  <Link
                    onClick={() => setMenuOpen(false)}
                    to="/seller/profile"
                    className="bg-blue-600 text-white px-4 py-1 rounded-lg hover:bg-blue-700"
                  >
                    Seller Profile
                  </Link>

                  <Link
                    onClick={() => setMenuOpen(false)}
                    to="/seller/dashboard"
                    className="bg-green-600 text-white px-4 py-1 rounded-lg hover:bg-green-700"
                  >
                    Dashboard
                  </Link>

                  <button
                    onClick={() => {
                      setMenuOpen(false);
                      handleSellerLogout();
                    }}
                    className="bg-red-600 text-white px-4 py-1 rounded-lg hover:bg-red-700"
                  >
                    Logout
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
